// Bilingual content for Akwaan Express
export const translations = {
  ar: {
    dir: "rtl",
    nav: {
      home: "الرئيسية",
      about: "عن أكوان",
      services: "خدماتنا",
      apps: "حمّل التطبيق",
      partners: "كن شريكاً",
      faq: "الأسئلة الشائعة",
      contact: "اتصل بنا",
      cta: "ابدأ الآن",
    },
    breadcrumb: { home: "الرئيسية" },
    hero: {
      kicker: "شركة توصيل ذكية في العراق",
      title: ["نوصل ما يهمك،", "بسرعة وأمان", "في كل العراق"],
      subtitle:
        "أكوان إكسبرس — منصة لوجستية متكاملة متخصصة في توصيل البطاقات الإلكترونية والمستندات المالية وكافة أنواع الطرود في بغداد وجميع المحافظات، بنظام تتبع لحظي وتحقق OTP.",
      ctaPrimary: "حمّل التطبيق",
      ctaSecondary: "كن شريكاً معنا",
      stat1: "بطاقة وطرد موصلة بنجاح",
      stat2: "متوسط زمن التوصيل",
      stat3: "محافظة عراقية",
      stat4: "دعم ومتابعة",
    },
    marquee: ["توصيل سريع", "تحقق OTP", "تغطية كاملة", "تتبع لحظي", "دعم 24/7", "نظام أكوان", "أمان مالي", "+2.7M طرد"],
    about: {
      kicker: "عن أكوان إكسبرس",
      title: "شركة عراقية مرخّصة، تقودها التكنولوجيا والثقة",
      lead:
        "نحن أكوان المتحدة — شركة لوجستية متخصصة في خدمات التوصيل السريع، نعمل بشراكة استراتيجية مع البنوك والمؤسسات المالية في العراق لتوصيل البطاقات الإلكترونية والمستندات المالية بدقة وسرعة قياسية.",
      missionTitle: "رسالتنا",
      mission:
        "تقديم حلول توصيل سريع متكاملة وذكية، نربط فيها العميل والمندوب والجهة المتعاقدة في دورة عمل واحدة، مع ضمان الدقة والخصوصية والكفاءة التشغيلية.",
      visionTitle: "رؤيتنا",
      vision:
        "أن نكون الخيار الأول في العراق لخدمات التوصيل السريع والمتخصصة، عبر نظام تشغيلي ذكي يحترم وقت الجميع.",
      pillars: [
        { t: "تكنولوجيا تشغيلية", d: "نظام أكوان الداخلي يدير الطلبات من الإنشاء حتى التسليم النهائي." },
        { t: "تغطية وطنية", d: "فروع ومكاتب في 18 محافظة عراقية مع دعم لجميع المراكز والأطراف." },
        { t: "أمان وخصوصية", d: "بروتوكول OTP لكل تسليم، وأرشفة إلكترونية مشفّرة لجميع البيانات." },
        { t: "شراكة لا تعاقد", d: "مدير حساب مخصص لكل شريك، تقارير حية، ودعم فني وميداني 24/7." },
      ],
    },
    services: {
      kicker: "ماذا نقدّم",
      title: "خدمات توصيل احترافية ومتكاملة",
      lead: "حلول لوجستية مصمّمة للقطاع المالي والشركات التي تتطلب الدقة والسرعة.",
      items: [
        { t: "توصيل البطاقات الإلكترونية", d: "تسليم بطاقات الدفع الإلكتروني مباشرة لأصحابها مع تحقق OTP." },
        { t: "توصيل المستندات المالية", d: "نقل آمن للوثائق والعقود الحساسة بين الفروع والعملاء." },
        { t: "خدمة الاستلام", d: "نستلم الطرود من فروعكم أو من العملاء مباشرة وفق جدول مرن." },
        { t: "تتبع لحظي", d: "لوحة تحكم مباشرة لمتابعة كل طلب من الإنشاء حتى التسليم." },
        { t: "نظام تذاكر داخلي", d: "نظام تذاكر متكامل لرفع الملاحظات وحلّها بسرعة." },
        { t: "تقارير وأرشفة", d: "تصدير البيانات والتقارير بصيغة Excel، مع أرشيف مشفّر." },
        { t: "نظام الربط البرمجي (API)", d: "ربط تقني مباشر وسلس يتيح دمج خدماتنا مع أنظمتكم وبرامجكم الخاصة لأتمتة الطلبات." },
        { t: "التحقق الآمن (OTP)", d: "نظام التحقق عبر رمز المرور لمرة واحدة لضمان أعلى مستويات الأمان عند الاستلام والتسليم." },
      ],
    },
    coverage: {
      kicker: "تغطيتنا",
      title: "حاضرون في كل محافظة",
      lead: "شبكة فروع ومكاتب وفريق ميداني مدرّب يغطي بغداد وجميع محافظات العراق.",
      governorates: [
        "بغداد", "البصرة", "نينوى", "أربيل", "النجف", "كربلاء",
        "بابل", "ذي قار", "الأنبار", "ديالى", "كركوك", "السليمانية",
        "دهوك", "صلاح الدين", "واسط", "ميسان", "القادسية", "المثنى",
      ],
    },
    apps: {
      kicker: "تطبيقاتنا",
      title: "نظام أكوان في يدك",
      lead: "تطبيقات مخصصة للتاجر والمندوب — متوفرة الآن على Android و iOS.",
      cards: [
        {
          t: "تطبيق التاجر",
          d: "أدر طلباتك، حمّلها فردياً أو عبر Excel، وتابع حالتها لحظياً.",
          os: "Android",
          link: "https://play.google.com/store/apps/details?id=express.akwaan.merchant",
        },
        {
          t: "تطبيق التاجر (iOS)",
          d: "نسخة iPhone من تطبيق التاجر لإدارة الطلبات ومتابعتها من جهازك.",
          os: "iOS",
          link: "https://apps.apple.com/iq/app/akwaan-merchant/id6794922425",
        },
        {
          t: "تطبيق المندوب",
          d: "إدارة المهام الميدانية، التسليم بـ OTP، وتأكيد الاستلام.",
          os: "Android",
          link: "https://play.google.com/store/apps/details?id=express.akwaan.driver",
        },
        {
          t: "تطبيق المندوب (iOS)",
          d: "نسخة iPhone من تطبيق المندوب لإدارة مهام التوصيل من جهازك.",
          os: "iOS",
          link: "https://apps.apple.com/iq/app/akwaan-driver/id6794922243",
        },
      ],
    },
    partners: {
      kicker: "كن شريكاً",
      title: "هل أنت بنك أو شركة تبحث عن شريك توصيل موثوق؟",
      lead:
        "املأ النموذج أدناه وسيتواصل معك مدير شراكات مخصّص خلال 24 ساعة لتقديم عرض يناسب حجم عملياتك.",
      form: {
        company: "اسم الشركة / الجهة",
        contact: "اسم الشخص المسؤول",
        email: "البريد الإلكتروني",
        phone: "رقم الهاتف",
        gov: "المحافظة",
        type: "نوع النشاط",
        daily: "حجم الطلبات اليومي المتوقع",
        notes: "ملاحظات إضافية",
        submit: "إرسال طلب الشراكة",
        submitting: "جاري الإرسال...",
        success: "شكراً! استلمنا طلبك وسنتواصل معك قريباً.",
        error: "حدث خطأ، يرجى المحاولة مجدداً.",
        dailyOptions: ["1 - 100 طلب", "100 - 500 طلب", "500 - 1000 طلب", "+1000 طلب"],
      },
    },
    faq: {
      kicker: "الأسئلة الشائعة",
      title: "إجابات على ما يخطر ببالك",
      items: [
        { q: "ما هي طبيعة عمل أكوان إكسبرس؟", a: "نحن شركة توصيل ذكية متخصصة في توصيل البطاقات الإلكترونية والمستندات المالية للبنوك والشركات في جميع محافظات العراق." },
        { q: "ما هو متوسط زمن التوصيل؟", a: "أقل من 18 ساعة داخل المحافظة بدلاً من 72 ساعة في الخدمات التقليدية، بفضل نظامنا التشغيلي الذكي." },
        { q: "كيف تضمنون أمان البطاقات والمستندات؟", a: "نعتمد على تحقق OTP عند التسليم، أرشفة إلكترونية مشفّرة، فحص هوية المستلم، وتدقيق متعدد المراحل." },
        { q: "هل تغطّون جميع المحافظات؟", a: "نعم، لدينا فروع ومكاتب في كل المحافظات الـ18، وتشمل أسعارنا المراكز والأطراف." },
        { q: "كيف يمكنني الانضمام كشريك؟", a: "املأ نموذج الشراكة في الموقع أو راسلنا على sales@akwaan.com وسنتواصل معك خلال 24 ساعة." },
        { q: "هل يوجد تطبيق للأيفون؟", a: "نعم، تطبيق Akwaan Delivery متاح حالياً على App Store، وقريباً سننشر تطبيقات التاجر والمندوب لـ iOS." },
      ],
    },
    contact: {
      kicker: "اتصل بنا",
      title: "نحن هنا للإجابة على كل استفساراتك",
      lead: "اختر القناة الأنسب لك — نرد على رسائلكم خلال ساعات العمل الرسمية.",
      emails: {
        info: "للاستفسارات العامة",
        operation: "للعمليات والتشغيل",
        sales: "للشراكات والمبيعات",
      },
      address: "العراق - بغداد - الكرادة - قرب المسرح الوطني",
      phones: ["+964 788 588 4088"],
      formTitle: "أرسل لنا رسالة",
      form: {
        name: "الاسم الكامل",
        email: "البريد الإلكتروني",
        phone: "رقم الهاتف (اختياري)",
        subject: "الموضوع",
        message: "الرسالة",
        submit: "إرسال الرسالة",
        submitting: "جاري الإرسال...",
        success: "تم إرسال رسالتك بنجاح، شكراً لتواصلك.",
        error: "تعذّر الإرسال، حاول لاحقاً.",
      },
    },
    footer: {
      tag: "نوصل ما يهمك، بسرعة وأمان.",
      sections: { company: "الشركة", services: "خدماتنا", contact: "تواصل" },
      rights: "جميع الحقوق محفوظة لشركة أكوان المتحدة",
    },
    trust: {
      kicker: "شركاؤنا",
      title: "موثوق من قبل أبرز الشركات العراقية",
      lead: "نتعامل مع بنوك ومؤسسات وعلامات تجارية عراقية بارزة، نوصل بطاقاتها ومستنداتها وطرودها يومياً عبر نظام أكوان.",
      industries: {
        bank: "بنك",
        payments: "مدفوعات",
        retail: "تجزئة",
        luxury: "عطور فاخرة",
        media: "ميديا",
        telecom: "اتصالات",
        internet: "خدمات إنترنت",
        ecommerce: "متجر إلكتروني",
        digital: "خدمات رقمية",
      },
    },
  },

  en: {
    dir: "ltr",
    nav: {
      home: "Home",
      about: "About",
      services: "Services",
      apps: "Get the App",
      partners: "Partner",
      faq: "FAQ",
      contact: "Contact",
      cta: "Get Started",
    },
    breadcrumb: { home: "Home" },
    hero: {
      kicker: "Smart delivery — built in Iraq",
      title: ["We deliver", "what matters,", "across all of Iraq"],
      subtitle:
        "Akwaan Express is an integrated logistics platform specialized in delivering electronic payment cards, financial documents and all types of parcels — covering Baghdad and all governorates with live tracking and OTP verification.",
      ctaPrimary: "Download the App",
      ctaSecondary: "Become a Partner",
      stat1: "Cards & parcels successfully delivered",
      stat2: "Average delivery time",
      stat3: "Iraqi governorates",
      stat4: "Support & ops",
    },
    marquee: ["Express delivery", "OTP verification", "Nationwide reach", "Live tracking", "24/7 support", "Awan system", "Financial-grade security", "+2.7M parcels"],
    about: {
      kicker: "About Akwaan",
      title: "A licensed Iraqi company driven by technology and trust.",
      lead:
        "Akwaan Almutahida is a logistics company specializing in fast delivery, partnering with banks and financial institutions in Iraq to deliver payment cards and financial documents with record-breaking accuracy and speed.",
      missionTitle: "Our Mission",
      mission:
        "To provide integrated, smart express-delivery solutions that connect customers, drivers, and contracting parties in a single, secure operational cycle.",
      visionTitle: "Our Vision",
      vision:
        "To be the first choice in Iraq for specialized express delivery — through a smart operating system that respects everyone's time.",
      pillars: [
        { t: "Operational Tech", d: "Our internal Awan system manages every order from creation to final delivery." },
        { t: "Nationwide Coverage", d: "Branches across 18 Iraqi governorates, including centers and outskirts." },
        { t: "Security & Privacy", d: "OTP verification on every delivery, plus encrypted electronic archiving." },
        { t: "Partnership, not vendor", d: "Dedicated account manager, live reports, and 24/7 field & tech support." },
      ],
    },
    services: {
      kicker: "What we do",
      title: "Professional, end-to-end delivery services",
      lead: "Logistics solutions designed for the financial sector and businesses that demand precision and speed.",
      items: [
        { t: "Electronic Card Delivery", d: "We hand-deliver payment cards with OTP verification at the point of handover." },
        { t: "Financial Document Delivery", d: "Secure transport of contracts and sensitive documents between branches and clients." },
        { t: "Pickup Service", d: "We collect parcels from your branches or end customers on a flexible schedule." },
        { t: "Live Tracking", d: "A real-time partner dashboard to follow every order from creation to delivery." },
        { t: "Internal Ticketing", d: "Built-in ticketing system to raise and resolve issues quickly." },
        { t: "Reports & Archive", d: "Export reports in Excel and access an encrypted, durable archive." },
        { t: "API Integration", d: "A direct, seamless technical integration that plugs our service into your own systems to automate orders end-to-end." },
        { t: "Secure OTP Verification", d: "One-time passcode verification at pickup and handover to guarantee the highest level of delivery safety." },
      ],
    },
    coverage: {
      kicker: "Coverage",
      title: "Present in every governorate",
      lead: "A network of branches, offices, and trained field teams covering Baghdad and all of Iraq.",
      governorates: [
        "Baghdad", "Basra", "Nineveh", "Erbil", "Najaf", "Karbala",
        "Babil", "Dhi Qar", "Anbar", "Diyala", "Kirkuk", "Sulaymaniyah",
        "Duhok", "Saladin", "Wasit", "Maysan", "Qadisiyyah", "Muthanna",
      ],
    },
    apps: {
      kicker: "Our Apps",
      title: "The Akwaan system in your hand",
      lead: "Dedicated apps for merchants and drivers — available now on Android and iOS.",
      cards: [
        {
          t: "Merchant App",
          d: "Manage orders, upload them individually or via Excel, and track status in real time.",
          os: "Android",
          link: "https://play.google.com/store/apps/details?id=express.akwaan.merchant",
        },
        {
          t: "Merchant App (iOS)",
          d: "iPhone version of the merchant app — manage and track orders on the go.",
          os: "iOS",
          link: "https://apps.apple.com/iq/app/akwaan-merchant/id6794922425",
        },
        {
          t: "Driver App",
          d: "Run field tasks, complete OTP-verified deliveries, and confirm hand-overs.",
          os: "Android",
          link: "https://play.google.com/store/apps/details?id=express.akwaan.driver",
        },
        {
          t: "Driver App (iOS)",
          d: "iPhone version of the driver app — manage delivery tasks from your device.",
          os: "iOS",
          link: "https://apps.apple.com/iq/app/akwaan-driver/id6794922243",
        },
      ],
    },
    partners: {
      kicker: "Become a partner",
      title: "Are you a bank or a business looking for a reliable delivery partner?",
      lead:
        "Fill the form below and a dedicated partnerships manager will reach out within 24 hours with an offer tailored to your operations.",
      form: {
        company: "Company / Entity name",
        contact: "Primary contact",
        email: "Email",
        phone: "Phone number",
        gov: "Governorate",
        type: "Business type",
        daily: "Expected daily orders",
        notes: "Additional notes",
        submit: "Send partnership request",
        submitting: "Sending...",
        success: "Thank you! We received your request and will reach out shortly.",
        error: "Something went wrong, please retry.",
        dailyOptions: ["1 – 100 orders", "100 – 500 orders", "500 – 1000 orders", "1000+ orders"],
      },
    },
    faq: {
      kicker: "FAQ",
      title: "Answers to what's likely on your mind",
      items: [
        { q: "What does Akwaan Express do?", a: "We are a smart delivery company specialized in delivering electronic payment cards and financial documents for banks and businesses across all Iraqi governorates." },
        { q: "What is the average delivery time?", a: "Under 18 hours within a governorate (vs. 72 hours in traditional services), thanks to our smart operations system." },
        { q: "How do you ensure card and document safety?", a: "We rely on OTP verification at delivery, encrypted electronic archiving, recipient ID checks, and multi-stage auditing." },
        { q: "Do you cover all governorates?", a: "Yes — branches and offices in all 18 governorates, with centers and outskirts included in our pricing." },
        { q: "How can I sign up as a partner?", a: "Fill the partnership form on this site or email sales@akwaan.com — we'll get back to you within 24 hours." },
        { q: "Is there an iPhone app?", a: "Yes, the Akwaan Delivery app is available on the App Store. iOS apps for merchants and drivers are coming soon." },
      ],
    },
    contact: {
      kicker: "Contact",
      title: "We're here to answer every question",
      lead: "Pick the channel that suits you — we reply during official working hours.",
      emails: {
        info: "General inquiries",
        operation: "Operations & dispatch",
        sales: "Partnerships & sales",
      },
      address: "Iraq — Baghdad — Karrada — near the National Theater",
      phones: ["+964 788 588 4088"],
      formTitle: "Send us a message",
      form: {
        name: "Full name",
        email: "Email",
        phone: "Phone (optional)",
        subject: "Subject",
        message: "Message",
        submit: "Send message",
        submitting: "Sending...",
        success: "Your message was sent successfully. Thank you!",
        error: "Couldn't send, please retry later.",
      },
    },
    footer: {
      tag: "We deliver what matters, fast and safe.",
      sections: { company: "Company", services: "Services", contact: "Contact" },
      rights: "All rights reserved — Akwaan Almutahida",
    },
    trust: {
      kicker: "Our Partners",
      title: "Trusted by leading Iraqi companies",
      lead: "We deliver daily for top Iraqi banks, payment providers and brands — cards, documents and parcels — through the Akwaan operating system.",
      industries: {
        bank: "Bank",
        payments: "Payments",
        retail: "Retail",
        luxury: "Luxury fragrance",
        media: "Media",
        telecom: "Telecom",
        internet: "Internet services",
        ecommerce: "E-commerce",
        digital: "Digital services",
      },
    },
  },
};
